export const ZOOM_INTERACTION = {
	zoom: ['brush', 'wheel', 'pinch', 'tapAndDrag', 'doubleTapReset'],
	pan: [
		{ type: 'pressAndDrag', allowedDirection: ['x', 'y'] },
		{ type: 'wheel', allowedDirection: ['x', 'y'] },
	],
}

export const ZOOM_OPTIONS = {
	minSpan: 0.5,
	maxSpan: 100,
	minStart: 0,
	maxEnd: 100,
	panning: true,
}

export const FIELD_COLORS = Object.freeze({
	alkalinity: '#2196f3',
	ph: '#4caf50',
	temperature: '#ff9800',
	conductivity: '#9c27b0',
})

const FALLBACK_COLORS = [
	'#2196f3', '#4caf50', '#ff9800', '#9c27b0',
	'#e91e63', '#00bcd4', '#ff5722',
]

export const getFieldColor = (field, fallbackIndex = 0) =>
	FIELD_COLORS[field] ?? FALLBACK_COLORS[fallbackIndex % FALLBACK_COLORS.length]
